import type { FC } from 'react';
import { Download, LayoutDashboard } from 'lucide-react';
import PulseHistoryIcon from './PulseHistoryIcon';

const HeroFeatures: FC = () => {
  return (
    <div className="mx-auto mt-20 max-w-5xl text-left">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-4 sm:w-1/3">
            <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-purple-50 text-purple-600 shadow-sm border border-zinc-200 dark:border-purple-200">
            <Download size={28} strokeWidth={1.2} />
          </div>
          <div>
            <div className="text-sm font-bold uppercase tracking-[0.15em] text-zinc-900">CAPTURE</div>
            <div className="mt-1 text-sm font-normal text-zinc-500">Capture every trade automatically.</div>
          </div>
        </div>

        <div className="flex items-start gap-4 sm:w-1/3">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-pink-50 text-pink-600 shadow-sm border border-zinc-200 dark:border-pink-200">
            <LayoutDashboard size={28} strokeWidth={1.2} />
          </div>
          <div>
            <div className="text-sm font-bold uppercase tracking-[0.15em] text-zinc-900">UNDERSTAND</div>
            <div className="mt-1 text-sm font-normal text-zinc-500">Reveal the habits driving your performance.</div>
          </div>
        </div>

        <div className="flex items-start gap-4 sm:w-1/3">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 shadow-sm border border-zinc-200 dark:border-green-200">
            <PulseHistoryIcon size={32} strokeWidth={1.2} />
          </div>
          <div>
            <div className="text-sm font-bold uppercase tracking-[0.15em] text-zinc-900">IMPROVE</div>
            <div className="mt-1 text-sm font-normal text-zinc-500">Review every execution to improve your next one.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroFeatures;
